module.exports = __webpack_public_path__ + "static/media/arrow_down.215db4c2.svg";